window.addEventListener('DOMContentLoaded', () => {
  function imagesPreFetch(images) {
    images.forEach((src) => {
      const img = new Image();
      img.src = src; 
    })
  }
  function productCardSlider() {
    const grid = document.getElementById("ProductGridContainer");
    grid.addEventListener("click", event => {
      const target = event.target;
      if (!target.classList.contains("card__inner--button")) return;

      const productCard = target.closest(".product-card-wrapper");
      if (!productCard) return;

    
      const images = JSON.parse(productCard.dataset.images);
      const imagesLength = images.length;
      imagesPreFetch(images);
      const imageTag = productCard.querySelector(".media > img");
      let currentIndex = +productCard.dataset.count || 0;

      if (target.classList.contains("next-media")) {
        currentIndex = (currentIndex + 1) % imagesLength;
      } else {
        currentIndex = (currentIndex + imagesLength - 1) % imagesLength;
      }

      productCard.dataset.count = currentIndex;
      imageTag.src = images[currentIndex];
    })
  }
  productCardSlider();
})